const fetchData = async (url: string, data:any) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
    if (!response.ok) {
        throw new Error('An error occurred while fetching data')
    }
    return await response.json()
}

export default {fetchData}
